export default function Privacy() {
  return (
    <section>
      <div className='container mx-auto mb-6'>
        <h2 className="font-semibold">Privacy Policy</h2>
        <p>Last update: March 1st, 2026</p>
      </div>
      
      <div className='container mx-auto mb-6'>
        <h3>1. Data Collection</h3>
        <p>We collect information you voluntarily provide and data captured automatically:</p>
        <p>Personal Information: Name, nickname, email, phone number, residential address, and photo.</p>
        <p>Technical Data: IP address, cookies, and access logs for security and analytics purposes.</p>
      </div>

      <div className='container mx-auto mb-6'>
        <h3>2. Purpose</h3>
        <p>The collected data is used exclusively for real estate brokerage services.</p>
        <p>Note: A valid email address or phone number is required so we can respond to your inquiries.</p>
      </div>

      <div className='container mx-auto mb-6'>
        <h2>3. Sharing and Storage</h2>
        We do not sell your data. 
        Stored in safety environment from servers located in São Paulo/SP, we share only when under legal obligation ou to execute brokerage services initiated from the data owner.
      </div>
      <div className='container mx-auto mb-6'>
        <h2>5. Your rights</h2>
        By the LGPD law - Law number 13.709/18, and General Data Protection Regulation (GDPR), you have the right to know, access, edit, anonimize or exclude your data at any given time.
      </div>

      <div className='container mx-auto mb-6'>
        <h3>6. Data Protection Officer (DPO)</h3>
        <p>If you have questions regarding your privacy, please contact:</p>
        <p>DPO: Rodrigo da Silva Sakae</p>
        <p>Email: dpo@devsakae.com.br</p>
      </div>

    </section>
  );
}

